import React, { useState } from "react";
import "../supplierAndManufacturers.scss";
import { CategoryOrSubcategoryItem } from "./TableBody";
import { Dropdown } from "react-bootstrap";

const StatusData = [{
  id: 0,
  label: 'Active',
  key: 1
},
{
  id: 1,
  label: 'Inactive',
  key: 0
}]

const ViewHeader = ({
  name = '',
  icon,
  description = '',
  categoriesSelectedList = [],
  subCategoriesSelectedList = [],
  contact = '',
  activationDate = 'NA',
  website,
  isActive = false,
  changeStatus = () => { }
}) => {
  const [status, setStatus] = useState(StatusData[isActive ? 0 : 1])

  function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("T")[0].split("-");
    return `${day?.padStart(2, "0")}/${month?.padStart(2, "0")}/${year?.padStart(4, "0")}`;
  }

  return (
    <div className="viewHeader">
      <div className="d-flex align-items-start">
        {icon && <img src={icon} width={48} height={48} alt="company logo" className="rounded-full mr-3" />}
        <div>
          <div className="label">{name}</div>
          <div className="description">{description}</div>
          {
            categoriesSelectedList?.length > 0 && <div className="d-flex align-items-center">
              {
                categoriesSelectedList?.map((dataItem) => {
                  return (
                    <div className="mr-2">
                      <CategoryOrSubcategoryItem name={dataItem?.Name} color={dataItem?.Icon} />
                    </div>
                  )
                })
              }
              {
                subCategoriesSelectedList?.map((dataItem) => {
                  return (
                    <div className="mr-2">
                      <CategoryOrSubcategoryItem name={dataItem?.Name} color={dataItem?.Icon} />
                    </div>
                  )
                })

              }
            </div>
          }
          <div className="dataItem">Contact: {contact}</div>
          <div className="dataItem">Activation Date:
            <img src={'/images/settings-nav/supplier_and_manufacturers_datepicker.svg'} width={14} height={14} alt="data icon" className="mx-2" />
            <span>{formatDateToDDMMYYYY(activationDate)}</span>
          </div>
          {
            website && <div className="linkItem" onClick={() => { window.open(website, "_blank"); }}>
              <span>Suppliers's site</span>
              <img src={'/images/supply-chain/blue-redirect.svg'} width={12} height={12} alt="data icon" className="mx-2 mb-1" />
            </div>
          }
        </div>
      </div>

      <StatusDropdown status={status} setStatus={setStatus} changeStatus={changeStatus} />
    </div>
  )
}

export default ViewHeader;

const StatusDropdown = ({
  status = StatusData[0],
  setStatus = () => { },
  changeStatus = () => { },
}) => (
  <Dropdown className="transparennt-wrapper-dropdown">
    <Dropdown.Toggle>
      <div className={`statusLabel ${status?.id === 0 ? 'bg-green-light' : 'bg-darkgrey'}`}>
        <span>{status?.label}</span>
        <img src={' /images/chevron-down-white.svg'} width={11} height={7} alt="" className="ml-2" />
      </div>
    </Dropdown.Toggle>
    <Dropdown.Menu renderOnMount>
      {
        StatusData?.map((statusItem) => {
          let isSelected = status?.id === statusItem?.id;
          return (
            <div className="statusDropdownItem" onClick={(e) => {
              setStatus(statusItem);
              changeStatus(statusItem?.key);
              e.target.closest(".transparennt-wrapper-dropdown").click();
            }}
            >
              {isSelected ? <img alt="" src="/images/msp/dropdown-grey-tick.svg" /> : <div style={{ width: '12px' }}></div>}
              <span className="ml-2">{statusItem?.label}</span>
            </div>
          )
        })
      }
    </Dropdown.Menu>
  </Dropdown>
)
